import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import EditDiscovery from 'view/page/discovery-management/component/edit-discovery'
import formatArticle from 'helper/format-input-fields'
import PropTypes from 'prop-types'
import EditAuthor from 'view/component/table-columns/common-actions/edit-author'
import DeleteDiscovery from './component/delete'
import PinDiscovery from './component/pin'
import PublishDiscovery from './component/publish'
import styles from './styles'

const Action = ({ discovery }) => (
  <span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <EditDiscovery discovery={formatArticle(discovery)} />
          </Menu.Item>
          <Menu.Item>
            <DeleteDiscovery discovery={discovery} />
          </Menu.Item>
          <Menu.Item>
            <PublishDiscovery discovery={discovery} />
          </Menu.Item>
          <Menu.Item>
            <PinDiscovery discovery={discovery} />
          </Menu.Item>
          <Menu.Item>
            <EditAuthor article={formatArticle(discovery)} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  discovery: PropTypes.object
}

export default Action
